import isBox44Path from 'views/declarations/common/declaration-errors-drawer/declaration-errors/error-cards/isBox44Path';
import { useRevealDeclarationField } from 'views/declarations/utils/revealDeclarationField';
import { useBox44Context } from './Box44';

/**
 * Opens a Box 44 modal when a field in Box 44 is asked to be shown, e.g. by an error in the errors
 * drawer. The declaration and an item each render their own modal, so only the one on screen takes
 * the request. Which paths are Box 44 comes from the context the modal edits.
 */
const useOpenBox44OnRequest = (isEnabled: boolean, open: () => void) => {
    const { path: box44Path } = useBox44Context();

    useRevealDeclarationField((fieldPath) => {
        if (!isEnabled || !isBox44Path(fieldPath, box44Path)) return false;

        open();
        return true;
    });
};

export default useOpenBox44OnRequest;
